/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object, shape, string } from 'prop-types';
import { Link } from 'react-router-dom';
import withStyles from '@material-ui/core/styles/withStyles';
import { useDispatch } from 'react-redux';

import { determineCollectionPrefixPath } from '../../../../../../helpers/determineInternationalizationPath';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Helpers';

const styles = (theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        overflow: 'hidden',
        backgroundColor: theme.palette.background?.paper,
        textAlign: 'center',
        color: theme.palette.colorNeutral70,
        fontSize: '14px',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    },
    listItem: {
        margin: '0 1.8%',
        textDecoration: 'none',
    },
    title: {
        color: theme.palette.common?.black,
        textDecoration: 'none',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    },
    plantsTitle: {
        color: theme.palette.common?.black,
        textDecoration: 'none',
        fontFamily: 'Hind, sans-serif',
        '@media (max-width: 767px)': {
            marginTop: '0.5rem',
            marginBottom: '1.5rem',
        },
    },
    tileIcon: {
        width: '130px',
        height: '130px',
        borderRadius: '50%',
        border: `2px solid ${theme.palette.categoryCarousalBorder}`,
        padding: '10px',
    },
    plantsTileIcon: {
        width: '138px',
        height: '138px',
        borderRadius: '100%',
    },
});

const determainCollectionPath = (url, brand) => {
    if (brand?.code === '08F') {
        return determineCollectionPrefixPath(url, true);
    }
    return determineCollectionPrefixPath(url, false);
};

const determinePath = (presentation_family, url, brand) => {
    const targetURL = presentation_family === 'growthbrand' ? determainCollectionPath(url, brand) : url;
    return targetURL;
};

const GraphqlHPCategoryCarouselUI = ({
    classes, tileData, presentationFamily, brand,
}) => {
    const dispatch = useDispatch();
    return (
        <Link
            key={tileData?.link?.href}
            to={determinePath(presentationFamily, tileData?.link?.href, brand)}
            className={classes.listItem}
            dispatch={() => {
                dispatch(trackEvent({
                    eventCategory: 'FAGF', eventAction: '', eventLabel: '',
                }));
            }}
        >
            <img className={brand?.code === 'PLA' ? classes.plantsTileIcon : classes.tileIcon} src={tileData?.mobile_image?.url} alt={tileData?.link?.title} />
            <div className={brand?.code === 'PLA' ? classes.plantsTitle : classes.title}>
                {tileData?.link?.title}
            </div>
        </Link>
    );
};

GraphqlHPCategoryCarouselUI.propTypes = {
    brand: shape({
        code: string,
    }).isRequired,
    tileData: shape({
        link: shape({
            href: string.isRequired,
            title: string.isRequired,
        }),
        mobile_image: shape({
            url: string.isRequired,
        }),
    }).isRequired,
    classes: object.isRequired,
    presentationFamily: string.isRequired,
};

export default withStyles(styles)(GraphqlHPCategoryCarouselUI);
